/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const BreadcrumbFragment = {
  Breadcrumb: gql`
    fragment BreadcrumbQuery on breadcrumbs_Entry {
      hideOnMobile
      styles
      breadcrumbsList {
        ... on breadcrumbsListBlock_Entry {
          breadcrumbLink
          breadcrumbText
        }
      }
      typeHandle
    }
  `,
};
